import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const insuranceValue = (state, props) => (
  whatIfInnerSelector(state, props).HomeInsurancePerYear
);

export default insuranceValue;
